/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Button from '~/components/button';
import Container from '~/components/container';
import ContainerFlex from '~/components/containerFlex';
import Input, { MaskTypes } from '~/components/input';
import Loading from '~/components/loading';
import TableList from '~/components/tableList';
import useApi, { ApiMethod } from '~/hooks/useApi';
import ConsultUserSearchResponse from '~/services/consult/user/search/response';
import Endpoints from '~/services/endpoints';
import { FormField, setFormState } from '~/utils/form';
import { IListColCampaing } from '~/views/Resource/Campaing/model';
import { TitleCategory } from '../styles';

import * as St from './styles';

interface Form {
  cpf: FormField;
  numeroCartao: FormField;
  nome: string;
}

const ClientSearch = () => {
  const history = useHistory();
  const [list, setList] = useState([]);

  const [form, setForm] = useState<Form>({
    cpf: { name: 'cpf', value: '' },
    numeroCartao: { name: 'numeroCartao', value: '' },
    nome: '',
  });

  const handleGenerateURL = useMemo(() => {
    if (form.cpf?.unmasked && form.numeroCartao?.unmasked && form.nome) {
      return `${Endpoints.consult.searchUser}?cpf=${form.cpf?.unmasked}&numeroCartao=${form.numeroCartao?.unmasked}&nome=${form.nome}`;
    }

    if (!form.cpf?.unmasked && form.numeroCartao?.unmasked && form.nome) {
      return `${Endpoints.consult.searchUser}?numeroCartao=${form.numeroCartao?.unmasked}&nome=${form.nome}`;
    }

    if (form.cpf?.unmasked && !form.numeroCartao?.unmasked && form.nome) {
      return `${Endpoints.consult.searchUser}?cpf=${form.cpf?.unmasked}&nome=${form.nome}`;
    }

    if (form.cpf?.unmasked && form.numeroCartao?.unmasked && !form.nome) {
      return `${Endpoints.consult.searchUser}?cpf=${form.cpf?.unmasked}&numeroCartao=${form.numeroCartao?.unmasked}`;
    }

    if (!form.cpf?.unmasked && !form.numeroCartao?.unmasked && form.nome) {
      return `${Endpoints.consult.searchUser}?nome=${form.nome}`;
    }

    if (form.cpf?.unmasked && !form.numeroCartao?.unmasked && !form.nome) {
      return `${Endpoints.consult.searchUser}?cpf=${form.cpf?.unmasked}`;
    }

    return `${Endpoints.consult.searchUser}?numeroCartao=${form.numeroCartao?.unmasked}`;
  }, [form]);

  const api = useApi<ConsultUserSearchResponse>(
    handleGenerateURL,
    ApiMethod.GET,
  );

  const customerHeader = [
    {
      id: 1,
      value: 'Nome completo',
      maxChar: 30,
      textAlign: 'left',
    },
    {
      id: 2,
      value: 'CPF',
      maxChar: 30,
      textAlign: 'center',
    },
    {
      id: 3,
      value: 'Tipo',
      maxChar: 20,
      textAlign: 'center',
    },
    {
      id: 4,
      value: 'Número do cartão',
      maxChar: 30,
      textAlign: 'center',
    },
    {
      id: 5,
      value: 'Ação',
      maxChar: 10,
      textAlign: 'center',
    },
  ];

  useEffect(() => {
    loadData();
  }, [api.loading]);

  const searchUser = () => api.callApi(); // fazer validação

  const goToDetail = (a: any, item: any) => {
    history.push('/invoice/purchase-inclusion/detail', {
      cpf: item.cpf,
      nome: item.nome,
      cartoes: item.cartoes,
    });
  };

  const loadData = () => {
    if (api.status !== 200) {
      setList([]);
      return;
    }

    const dataRes = api.data as ConsultUserSearchResponse[];

    const newList = [];

    dataRes.forEach((data, clientIndex) => {
      const isLastClient = clientIndex === dataRes.length - 1;
      const cartoes = data.cartoes || [];

      if (cartoes.length === 0) {
        const item: IListColCampaing[] = [
          {
            border: true,
            title: 'Nome completo',
            value: data.nome,
            maxChar: 30,
            textAlign: 'left',
            isLastRowOfGroup: !isLastClient,
          },
          {
            border: true,
            title: 'CPF',
            value: data.cpf,
            maxChar: 15,
            textAlign: 'center',
            isLastRowOfGroup: !isLastClient,
          },
          {
            title: 'Tipo',
            value: '-',
            maxChar: 20,
            textAlign: 'center',
            isLastRowOfGroup: !isLastClient,
          },
          {
            title: 'Número do cartão',
            value: '-',
            maxChar: 30,
            textAlign: 'center',
            isLastRowOfGroup: !isLastClient,
          },
          {
            item: data,
            maxChar: 8,
            textAlign: 'right',
            searchAction: goToDetail,
            isLastRowOfGroup: !isLastClient,
          },
        ];

        newList.push(item);
        return;
      }

      const totalRows = cartoes.length;

      cartoes.forEach((cartao, index) => {
        const isFirstRow = index === 0;
        const isLastRow = index === totalRows - 1;

        const item: IListColCampaing[] = [
          {
            border: true,
            title: 'Nome completo',
            value: data.nome,
            maxChar: 30,
            textAlign: 'left',
            rowSpan: isFirstRow ? totalRows : undefined,
            hidden: !isFirstRow,
            isLastRowOfGroup: isFirstRow && !isLastClient,
          },
          {
            border: true,
            title: 'CPF',
            value: data.cpf,
            maxChar: 15,
            textAlign: 'center',
            rowSpan: isFirstRow ? totalRows : undefined,
            hidden: !isFirstRow,
            isLastRowOfGroup: isFirstRow && !isLastClient,
          },
          {
            title: 'Tipo',
            value: cartao.tipoCartao || '-',
            maxChar: 20,
            textAlign: 'center',
            showBottomBorder: !isLastRow,
            isLastRowOfGroup: isLastRow && !isLastClient,
          },
          {
            title: 'Número do cartão',
            value: cartao.numeroCartao || '-',
            maxChar: 30,
            textAlign: 'center',
            showBottomBorder: !isLastRow,
            isLastRowOfGroup: isLastRow && !isLastClient,
          },
          {
            item: data,
            maxChar: 8,
            textAlign: 'right',
            searchAction: goToDetail,
            rowSpan: isFirstRow ? totalRows : undefined,
            hidden: !isFirstRow,
            isLastRowOfGroup: isFirstRow && !isLastClient,
          },
        ];

        newList.push(item);
      });
    });

    setList(newList);
  };

  return (
    <>
      <Loading status={api.loading} />

      <Container>
        <St.BoxCard>
          <ContainerFlex row space>
            <ContainerFlex padding={16}>
              <Input
                label="CPF"
                name={form.cpf.name}
                value={form.cpf.value}
                onChange={(e) => setFormState(e, form, setForm)}
                placeholder="000.000.000-00"
                maxLength={14}
                mask={MaskTypes.CPF}
              />
            </ContainerFlex>
            <ContainerFlex padding={16}>
              <Input
                label="Número do cartão"
                placeholder="0000.0000.0000.0000"
                maxLength={19}
                mask={MaskTypes.CREDIT_CARD}
                onChange={(e) => setFormState(e, form, setForm)}
                name={form.numeroCartao.name}
                value={form.numeroCartao.value}
              />
            </ContainerFlex>
            <ContainerFlex padding={16}>
              <Button
                fitContent
                onClick={searchUser}
                loading={api.loading}
                disabled={
                  (form.cpf.value.length !== 14 &&
                    form.numeroCartao.value.length !== 19 &&
                    !form.nome) ||
                  api.loading
                }
              >
                <span>Consultar</span>
              </Button>
            </ContainerFlex>
          </ContainerFlex>
        </St.BoxCard>

        {list.length <= 0 ? (
          <St.BoxCard>
            <ContainerFlex center>
              <TitleCategory>Cliente não encontrado!</TitleCategory>
            </ContainerFlex>
          </St.BoxCard>
        ) : (
          <St.BoxCard>
            <ContainerFlex row>
              {api.status === 404 && (
                <ContainerFlex center marginTop={30}>
                  <TitleCategory>{api.data?.mensagem}</TitleCategory>
                </ContainerFlex>
              )}

              {list.length > 0 && (
                <TableList
                  customerHeader={customerHeader}
                  list={list}
                  disableRowShadow
                />
              )}
            </ContainerFlex>
          </St.BoxCard>
        )}
      </Container>
    </>
  );
};

export default ClientSearch;
